import { LoadState } from "../../constants/enums";
import { IReportRevenue } from "./Report.types";

export const initialReportRevenue: IReportRevenue = {
  revenueReport: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  lostRevenue: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  peakBooking: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  upsellContribution: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  upsellContributionType: {
    data: null,
    loading: LoadState.Loaded,
    error: null,
  },
  ownerInsights: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  marginReport: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  ownerReportSummary: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  cancellationListReport: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  cancellationReasonListReport: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  guestVisitListReport: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  ongoingListReport: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  dailySummaryReport: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  weeklySummaryReport: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfCancellationGuestListLostRevenue: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfWeeklyGuestEventSummary: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  // New cancellation report states
  countOfCancellationLostRevenue: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfCancellationReasonList: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfCancellationList: {
    data: null,
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfGuestVisitList: {
    data: null,
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfGuestVisitChips: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  employeePerformanceReport: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfOngoingMoreThan15DaysChips: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfDailySummaryChips: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfWeeklySummaryChips: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfEmployeePerformanceReportChips: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  countOfOngoingAging: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  venuePerformanceOverview: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  eventSummary: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  eventTypeReport: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  roomReport: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  todayFollowupsList: {
    data: null,
    loading: LoadState.NotLoaded,
    error: null,
  },
  todaysCancellationList: {
    data: null,
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
